/**
 * Hook đóng overlay khi scroll trang; bỏ qua scroll trong panel/dropdown nội bộ.
 */
import { useEffect } from 'react';

const SCROLL_INSIDE_SELECTOR = [
  '.dropdown-shell',
  '.dropdown-shell-body',
  '.header-search-mobile-overlay',
  '.search-autocomplete-panel',
  '.header-search-panel',
  '.category-dropdown-panel',
  '.category-dropdown-panel-body',
  '.category-dropdown-list',
  '.header-menu-panel',
  '.home-header-menu-panel',
  '.action-dialog-panel',
].join(', ');

const isScrollInsideOverlay = (target) => {
  if (!(target instanceof Element)) {
    return false;
  }

  return Boolean(target.closest(SCROLL_INSIDE_SELECTOR));
};

/** @param {boolean} isOpen - Overlay đang mở */
export const useCloseOnScroll = (isOpen, onClose) => {
  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const handleScroll = (event) => {
      if (isScrollInsideOverlay(event.target)) {
        return;
      }

      onClose();
    };

    window.addEventListener('scroll', handleScroll, true);

    return () => {
      window.removeEventListener('scroll', handleScroll, true);
    };
  }, [isOpen, onClose]);
};
